import Tool from '../Tool';
import { makeWhiteboardToolHandler } from './helpers';

/**
 * Handler for WhiteboardAgent::GetCurrentWhiteboardContentTool
 * Provides whiteboard data to the tool call
 */
const getCurrentWhiteboardContentToolHandler = makeWhiteboardToolHandler(
  undefined,
  (toolCall, assistedWhiteboard) => {
    return {
      whiteboardData: {
        objects: assistedWhiteboard.getContentSummary(),
      },
    };
  }
);

Tool.register(
  'WhiteboardAgent::GetCurrentWhiteboardContentTool',
  getCurrentWhiteboardContentToolHandler
);
